module.exports = __webpack_public_path__ + "img/气球.1975ad45.svg";